import { useEffect, useState } from "react";

import { XIcon } from "lucide-react";

import type { OpenAPI } from "simplydo/interfaces";
import { Loader } from "simplydo/react/ui/loader";

import api from "api";

import ChallengeOverview from "components/challenges/Challenge/Overview";
import type { GenAIChallengeDraft } from "components/challenges/types";

import type { IdeaChallengeHelpProps } from "./types";

const IdeaChallengeHelp = ({ challengeId }: IdeaChallengeHelpProps) => {
  const [loading, setLoading] = useState(false);
  const [challenge, setChallenge] = useState<
    OpenAPI.GET<"/challenges/{id}/overview">["response"] | null
  >(null);

  useEffect(() => {
    setLoading(true);
    api.challenges.getOverview(
      challengeId,
      (newChallenge) => {
        setChallenge(newChallenge);
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, [challengeId]);

  return loading ? (
    <Loader />
  ) : challenge ? (
    <ChallengeOverview challenge={challenge as GenAIChallengeDraft} isPreview />
  ) : null;
};

export default IdeaChallengeHelp;
